import { emptyFragment } from '@execonline-inc/execonline-ui';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { ExperienceResource } from '../../../../Types';
import PopoverContent from '../PopoverContent';

export interface Props {
  experienceResource: Maybe<ExperienceResource>;
  sectionIndex: number;
  editable?: boolean;
}

function ExperienceCard({ experienceResource, sectionIndex, editable = false }: Props) {
  return experienceResource
    .map((experienceResource) => (
      <PopoverContent
        experienceResource={experienceResource}
        sectionIndex={sectionIndex}
        editable={editable}
      />
    ))
    .getOrElse(emptyFragment);
}

export default observer(ExperienceCard);
